import React from 'react';
import html from '../../images/html-5.png';
import css from '../../images/css.png';
import sass from '../../images/sass.png';
import mui from '../../images/mui.png';
import firebase from '../../images/firebase.png';
import github from '../../images/github.png';
import react from '../../images/react.png';
import js from '../../images/js.png';
import next from '../../images/next.png';
import node from '../../images/nodejs.png';
import chartjs from '../../images/chartjs.png';
import API from '../../images/api.png';
import emailjs from '../../images/emailjs.png';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import { makeStyles } from '@material-ui/core';






const useStyles = makeStyles(() => ({
  box: {
    textAlign: 'center',
    padding: '15%',
    borderRadius: '15px',
    margin: '0 5%',
    height: 'auto',
  },
  div: {
    padding: '0 5%',
  },
  p: {
    fontWeight: 'bold',
    marginTop: '5%',
  }
}))




export default function Gallery () {

    
  const classes = useStyles()


  const handleDragStart = (e) => e.preventDefault();


  const skills_img = [html, css, sass, js, mui, firebase, github, react, next, node, chartjs, API, emailjs]
  const skills = ['HTML 5', 'CSS 3', 'SASS', 'JavaScript', 'MaterialUI', 'Firebase', 'Github', 'React', "Next.js", 'Node.Js', 'Chart.js', 'API', "Email.js"];


  const skills_elements = skills_img.map((each, id) => {
    return (
        <article className={classes.box}>
          <img src={each} />
          <p className={classes.p}> {skills[id]} </p>
        </article>
    )
  });


  const responsive = {
    0:{
      items: 2
    },
    512:{
      items: 3
    },
    600:{
      items: 4
    },
    800:{
      items: 6
    },
  }






  return (
    <div className={classes.div}>
      <AliceCarousel 
        mouseTracking
        touchTracking
        autoPlayInterval={1000 / 2}
        animationDuration={1500}
        items={skills_elements}
        responsive = {responsive}
        autoPlay 
        infinite
        disableButtonsControls
        style={{paddingTop: '2%'}}
        autoHeight
      />
    </div>
  );
}
